<template>
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :multi-line="snackbar.multi"
    :timeout="snackbar.timeout"
    :top="true"
  >
    {{ snackbar.text }}
    <v-btn small text @click="handleAction">{{ actionText }}</v-btn>
  </v-snackbar>
</template>

<script>
// deps
import { mapGetters } from 'vuex'
// export
export default {
  // name
  name: 'Snackbar',
  // data
  data() {
    return {}
  },
  // computed
  computed: {
    // mapGetters
    ...mapGetters({ snackbar: 'getSnackbar' }),
    // actionText
    actionText() {
      return this.snackbar.actionText ? this.snackbar.actionText : 'إخفاء'
    }
  },
  // methods
  methods: {
    // action
    handleAction() {
      if (this.snackbar.action) {
        return this.snackbar.action()
      } else {
        return this.hideSnackbar()
      }
    },
    // hide Snackbar
    hideSnackbar() {
      this.snackbar.show = false
    }
  }
}
</script>
